export const DEFAULT_ACTION = 'screen/PostAnnounceFormDetailScreen/DEFAULT_ACTION';
export const UPDATE_INPUT = 'screen/PostAnnounceFormDetailScreen/UPDATE_INPUT';

export const GET_DETAIL_TODO = 'screen/PostAnnounceFormDetailScreen/GET_DETAIL_TODO';
export const GET_DETAIL_TODO_LOADING = 'screen/PostAnnounceFormDetailScreen/GET_DETAIL_TODO_LOADING';
export const GET_DETAIL_TODO_SUCCESS = 'screen/PostAnnounceFormDetailScreen/GET_DETAIL_TODO_SUCCESS';
export const GET_DETAIL_TODO_FAIL = 'screen/PostAnnounceFormDetailScreen/GET_DETAIL_TODO_FAIL';

export const ADD_IMAGE = 'screen/PostAnnounceFormDetailScreen/ADD_IMAGE';
export const DEL_IMAGE = 'screen/PostAnnounceFormDetailScreen/DEL_IMAGE';

export const SUBMIT_DETAIL = 'screen/PostAnnounceFormDetailScreen/SUBMIT_DETAIL';
export const SUBMIT_DETAIL_LOADING = 'screen/PostAnnounceFormDetailScreen/SUBMIT_DETAIL_LOADING';
export const SUBMIT_DETAIL_SUCCESS = 'screen/PostAnnounceFormDetailScreen/SUBMIT_DETAIL_SUCCESS';
export const SUBMIT_DETAIL_FAIL = 'screen/PostAnnounceFormDetailScreen/SUBMIT_DETAIL_FAIL';

export const SET_SAVED_DETAILS = 'screen/PostAnnounceFormDetailScreen/SET_SAVED_DETAILS';